import { editorialQuote, featureArticles } from "@/mocks/gossip";

export default function Feature() {
  const a = featureArticles[0];
  return (
    <section id="feature" className="paper-grain w-full py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-l-4 border-accent-500 pl-4">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-secondary-600">编辑部特稿 · Feature</p>
          <h2 className="font-heading text-3xl font-black text-foreground-950 md:text-4xl">深度翻旧账</h2>
        </div>

        <article className="mt-9 overflow-hidden rounded-lg border border-background-300/60 bg-background-50">
          <div className="relative h-64 w-full overflow-hidden md:h-80">
            <img
              src={a.img}
              alt={`${a.title} - 吃瓜八卦考古时间线深度报道`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="absolute bottom-0 left-0 w-full p-6 md:p-8">
              <span className="rounded-md bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                {a.eyebrow}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 p-6 md:p-8 lg:grid-cols-[1.6fr_1fr]">
            <div>
              <h3 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">{a.title}</h3>
              <p className="mt-4 font-display text-xl leading-relaxed text-accent-700">{a.lead}</p>
              <div className="mt-5 space-y-4">
                {a.body.map((para, i) => (
                  <p key={i} className="text-[15px] leading-relaxed text-foreground-700">
                    {para}
                  </p>
                ))}
              </div>
            </div>

            <aside className="flex flex-col gap-4">
              <div className="rounded-lg bg-foreground-900 p-6 text-background-100">
                <p className="font-heading text-xl font-bold leading-relaxed text-background-50">
                  “{editorialQuote.quote}”
                </p>
                <p className="mt-3 text-sm text-background-300">—— {editorialQuote.name}</p>
              </div>
              <div className="flex flex-col gap-3 rounded-lg border border-background-300/60 bg-background-100 p-5">
                <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <i className="ri-time-line text-secondary-600" />
                  阅读时间
                </div>
                <p className="text-sm leading-relaxed text-foreground-700">
                  全文约 {a.readMin} 分钟。带上一杯茶，慢慢把这段
                  <strong className="font-semibold text-foreground-900">陈年往事</strong>看到底。
                </p>
                <a
                  href="#subscribe"
                  className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  继续阅读特稿
                </a>
              </div>
            </aside>
          </div>
        </article>
      </div>
    </section>
  );
}